import { message } from 'antd';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;
const API_ROOT = `${SERVER_ADDRESS}`

const responseBody = response => response.json();

const catchError = err => {
  message.error(`${err.status && `${err.status}: `}${err.message || err}`, 2)
}

const createUrl = url => `${API_ROOT}${url}`;


const prepareData = (method = 'GET', body, headers) => {
  return {
    method,
    body: body && JSON.stringify(body),
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      ...headers
    },
  };
};

const requests = {

  post: (url, body = {}, headers) => {
    const data = prepareData('POST', body, headers);
    return fetch(createUrl(url), data)
      .then(responseBody)
      .catch(catchError)
  },


  get: (url,headers) => {
    const data = prepareData('GET',null,headers);
    return fetch(createUrl(url), data)
      .then(responseBody)
      .catch(catchError)
  },

  resolveIMagePath: imageId => {
    return createUrl(`/medium/file/${imageId}`)
  }
};


export default requests;
